/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { SalesLine } from "../storage/types";

export const hasMultiStores = (salesLines: SalesLine[] | undefined) => {
  const uniqueLocations = [...new Set(salesLines?.map((line) => line.inventoryLocationId))];
  return uniqueLocations.length > 1;
};
